module.exports = __webpack_public_path__ + "static/media/genistaHeader.3f2f2d6f.svg";